import React from 'react';

import s from './index.module.scss';

const HorizontalLine = () => (
  <div className={s['horizontal-line']} data-component="horizontal-line">
    <hr />
  </div>
);

export default HorizontalLine;
